import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { PlayerInjury } from '../../types/player';
import { useInjuryRequestService } from '../../lib/injury-request.service';

interface InjuryInfoSectionProps {
  playerInjuries: PlayerInjury[];
  playerId: string;
  playerName: string;
  playerClub: string;
}

export const InjuryInfoSection: React.FC<InjuryInfoSectionProps> = ({ 
  playerInjuries, 
  playerId, 
  playerName, 
  playerClub 
}) => {
  const { requestInjuryInfo } = useInjuryRequestService();
  const [isRequestingInfo, setIsRequestingInfo] = useState(false);
  
  // Get active injuries
  const activeInjuries = playerInjuries.filter(
    injury => !injury.until_date || new Date(injury.until_date) > new Date()
  );
  
  // Get injury details
  const injuryDetails = activeInjuries.map(injury => injury.injury).join(', ');
  
  // Get injury date
  const injuryDate = activeInjuries.length > 0 
    ? new Date(activeInjuries[0].from_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';
  
  // Handle requesting more information
  const handleRequestMoreInfo = async () => {
    if (!injuryDetails || !injuryDate) return;
    
    setIsRequestingInfo(true);
    try {
      await requestInjuryInfo(
        playerId,
        playerName,
        playerClub,
        injuryDetails,
        injuryDate
      );
    } finally {
      setIsRequestingInfo(false);
    }
  };
  
  return (
    <div className="mt-2 space-y-3">
      <div className="px-4 py-3 bg-[#26222E] text-[#CECFD2] rounded-lg shadow-lg border border-gray-500 text-sm">
        <span className="font-bold">Active Injury: </span>
        {injuryDetails}
      </div>
      
      {/* Show the button for all players on the KYP page */}
      <div className="flex justify-start">
        <button
          onClick={handleRequestMoreInfo}
          disabled={isRequestingInfo}
          className={`max-w-xs px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
            isRequestingInfo 
              ? "bg-[#26222E] text-[#CECFD2] opacity-50" 
              : "bg-transparent hover:bg-[#4E46FF] text-[#CECFD2] hover:text-white"
          }`}
        >
        {isRequestingInfo ? (
          <>
            <Loader2 className="inline-block h-4 w-4 mr-2 animate-spin" />
            Requesting...
          </>
        ) : (
          'Request More Information from Isokinetics'
        )}
        </button>
      </div>
    </div>
  );
};